import * as React from 'react';

import { FormControlLabel } from '@mui/material';
import { Field } from 'react-final-form';

import { Enum } from '@ha/utilities/Enum';

import { AvailabilityPeriodEnum } from '@kamernet/core/ApiClient/Kamernet';
import { useIntl } from '@kamernet/core/Intl';

import { Checkbox } from '@kamernet/components/FormFields/final-form/Checkbox/CheckboxInput';
import { AvailabilityPeriodTranslations } from '@kamernet/modules/Listing/translations';

import { SideFiltersFormFieldStyles } from './SideFiltersFormFieldStyles';

export const AvailabilityPeriodsFormField = () => {
  const { T } = useIntl();
  return (
    <section className={SideFiltersFormFieldStyles.controlsGroupRow}>
      {Enum.values(AvailabilityPeriodEnum).map(avilabilityPeriod => (
        <FormControlLabel
          key={avilabilityPeriod}
          control={
            <Field<number>
              name="availabilityPeriods"
              component={Checkbox}
              type="checkbox"
              value={avilabilityPeriod}
            />
          }
          label={T(AvailabilityPeriodTranslations[avilabilityPeriod])}
        />
      ))}
    </section>
  );
};
